export default {
  loadedProgress: (state) => state.loaded,
  progressText: (state) => state.text,
  uploadFilename: (state) => state.name,
}
